module.exports = __webpack_public_path__ + "static/img/banner-cx.e91228a0.jpg";